import { Fields } from '@/components/Form';
import {
  DatabaseMetadataFieldType,
  DatabaseViewFieldType,
  UpdateQuestionEntity,
} from '@/types/schema';

export enum DatabaseFormEditorActionEnum {
  DuplicateField = 'DUPLICATE_FIELD',
  RemoveField = 'REMOVE_FIELD',
  HideField = 'HIDE_FIELD',
  ReorderFields = 'REORDER_FIELDS',
  SelectField = 'SELECT_FIELD',
  UpdateField = 'UPDATE_FIELD',
}

export interface UpdateDatabaseFieldParams {
  fieldId: string;
  updates: {
    metadataField?: Partial<DatabaseMetadataFieldType>;
    viewField?: Partial<DatabaseViewFieldType>;
  };
}

export interface UpdateSurveyQuestionsFieldParams {
  fieldId: string;
  questionUpdates: UpdateQuestionEntity;
}

interface DuplicateFieldAction {
  type: DatabaseFormEditorActionEnum.DuplicateField;
  payload: { fieldId: string };
}

interface RemoveFieldAction {
  type: DatabaseFormEditorActionEnum.RemoveField;
  payload: { fieldId: string };
}

interface HideFieldAction {
  type: DatabaseFormEditorActionEnum.HideField;
  payload: { fieldId: string };
}

interface UpdateFieldAction {
  type: DatabaseFormEditorActionEnum.UpdateField;
  payload: UpdateDatabaseFieldParams;
}

interface UpdateSurveyQuestionsFieldAction {
  type: DatabaseFormEditorActionEnum.UpdateField;
  payload: UpdateSurveyQuestionsFieldParams;
}

interface SelectFieldAction {
  type: DatabaseFormEditorActionEnum.SelectField;
  payload: { fieldId: string | null };
}

interface ReorderFieldsAction {
  type: DatabaseFormEditorActionEnum.ReorderFields;
  payload: { fromIndex: number; toIndex: number };
}

export type DatabaseFormEditorAction =
  | HideFieldAction
  | DuplicateFieldAction
  | RemoveFieldAction
  | UpdateFieldAction
  | SelectFieldAction
  | ReorderFieldsAction;

export type SurveyQuestionsFormEditorActions =
  | HideFieldAction
  | DuplicateFieldAction
  | RemoveFieldAction
  | UpdateSurveyQuestionsFieldAction
  | SelectFieldAction
  | ReorderFieldsAction;

export interface DatabaseFormEditorError {
  type: string;
  message: string;
}

export interface DatabseFormEditorErrors {
  [key: string]: DatabaseFormEditorError;
}

export interface DatabaseFormEditorProps {
  isFieldPublished: (fieldId: string) => boolean;
  errors?: DatabseFormEditorErrors;
  getFieldAttributes: (fieldId: string) => { index: number; descriptionEnabled: boolean };
  selectedFieldId: string | null;
  onFormEditorAction?: (action: DatabaseFormEditorAction) => void;
  fields: Fields;
}
